module.exports = __webpack_public_path__ + "img/方框.f157561c.png";